import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  standalone: true,
  name: 'capitalize',
})
export class CapitalizePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';

    // Entferne führende und nachfolgende Leerzeichen
    value = value.trim();

    // Zerlege den String anhand von Leerzeichen
    const words = value.split(/\s+/); // Mehrere Leerzeichen als Trennzeichen behandeln

    const transformedWords = words.map((word, index) => {
      if (index === 0) {
        // Nur das erste Wort kapitalisieren
        return word.charAt(0).toUpperCase() + word.slice(1);
      }
      return word; // Andere Wörter unverändert lassen
    });

    return transformedWords.join(' '); // Wörter mit einem Leerzeichen verbinden
  }
}
